<div [formGroup]="form">
	<nz-form-item *ngIf="inline == false">
		<nz-form-label *ngIf="span != 0" [nzSpan]="span" [nzRequired]="wrapper.element.required">{{ wrapper.element.name }}</nz-form-label>
		<nz-form-label *ngIf="span == 0" [nzRequired]="wrapper.element.required">{{ wrapper.element.name }}</nz-form-label>

		<nz-form-control [nzAutoTips]="wrapper.autoTips">
			<nz-tree-select
				[name]="toControlKey(wrapper.element)"
				[nzNodes]="nodes"
				[nzAllowClear]="false"
				[nzExpandedKeys]="expandedKeys"
				nzShowSearch
				nzPlaceHolder="Please select"
				[(ngModel)]="selectedId"
				(ngModelChange)="change($event)"
				[ngModelOptions]="{standalone: true}"
				[nzDisabled]="readonly"/>
		</nz-form-control>
	</nz-form-item>
	<nz-form-item *ngIf="inline == true">
		<nz-form-control [nzAutoTips]="wrapper.autoTips">
			<nz-tree-select
				[name]="toControlKey(wrapper.element)"
				[nzNodes]="nodes"
				[nzAllowClear]="false"
				[nzExpandedKeys]="expandedKeys"
				nzShowSearch
				nzPlaceHolder="Please select"
				[(ngModel)]="selectedId"
				(ngModelChange)="change($event)"
				[ngModelOptions]="{standalone: true}"
				[nzDisabled]="readonly"/>
		</nz-form-control>
	</nz-form-item>
</div>
